import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-filters"
export default class extends Controller {
  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 200)
  }

  filter() {
    this.element.requestSubmit();
  }

  sort() {
    const target = document.getElementById(this.element.dataset['formId'])

    if(!target){
      console.log('! NO TARGET FOR SORT !')
      return
    }

    target.querySelector('#sort-column').value = this.element.dataset['sort'];
    target.querySelector('#sort-method').value = this.element.dataset['asc'];

    target.requestSubmit();
  }

  clear() {
    this.element.querySelectorAll('input, select').forEach((el) => { el.value = ''; });
    this.element.requestSubmit();
  }
}